import Countdown from 'react-countdown-now'
import React from 'react'
import clsx from 'clsx'
import { useStyles } from './styles'
import whiteLogo from 'assets/logo-iso-white.svg'

export const Header = ({ artist, disabledTheme, countdownCompleteCallback }) => {
    const classes = useStyles()
    return (
        <div className={clsx(classes.container, disabledTheme ? classes.disabledBg : classes.liveBg)}>
            <img className={classes.navLogo} src={whiteLogo} alt="Logo" />

            <p className={classes.heading}>Experience something exclusive with</p>
            <img
                className={clsx(classes.artistImg, disabledTheme && classes.grayscale)}
                src={artist.artistImg}
                alt={'Artist'}
            />
            <p className={classes.artistName}>{artist.name}</p>

            <div className={classes.countdownContainer}>
                <p className={classes.countdownTitle}>Priority List Closes:</p>
                <Countdown className={classes.countdown} onComplete={countdownCompleteCallback} date={artist.endTime} />
            </div>
        </div>
    )
}

export default Header
